import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { downloadFile, formatDateToISO } from '@ibk/shared-utils';
import { FileType } from '../../enums';
import { useGetExtractExportFile } from '../useGetExtractExportFile';
export function useExportExtract(onSuccess, onError) {
    const { t } = useTranslation();
    const { error, loading, exportExtractFile, getExtractExportFile, setError } = useGetExtractExportFile();
    const [startDate, setStartDate] = useState(undefined);
    const [endDate, setEndDate] = useState(undefined);
    const [format, setFormat] = useState(FileType.PDF);
    const disabled = useMemo(() => {
        return !startDate || !endDate || !format;
    }, [startDate, endDate, format]);
    useEffect(() => {
        if (exportExtractFile) {
            const fileData = [new Uint8Array(exportExtractFile.data)];
            downloadFile(`${t('extract').toLowerCase()}-${formatDateToISO(startDate)}-${formatDateToISO(endDate)}`, format, fileData);
            onSuccess();
        }
    }, [exportExtractFile, startDate, endDate, format, t, onSuccess]);
    useEffect(() => {
        if (error) {
            onError();
        }
    }, [error, onError]);
    function exportExtract() {
        if (startDate && endDate && format) {
            getExtractExportFile(startDate, endDate, format);
        }
        else {
            setError(true);
        }
    }
    return {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        format,
        setFormat,
        disabled,
        loading,
        exportExtract,
    };
}
